import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "cummings_admin_token";

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null); // null = checking, false = logged out, object = logged in

  const check = useCallback(async () => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) { setAdmin(false); return; }
    try {
      const { data } = await adminApi.get("/auth/me");
      setAdmin(data);
    } catch {
      localStorage.removeItem(TOKEN_KEY);
      setAdmin(false);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = async (email, password) => {
    const { data } = await adminApi.post("/auth/login", { email, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    setAdmin({ email: data.email, name: data.name, role: "admin" });
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setAdmin(false);
  };

  return <AuthContext.Provider value={{ admin, login, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
